import React, { useState, useEffect } from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import HeroArcs from './HeroArcs';
import Arc from './Arc';

export interface IAnimatedArcsProps extends IBaseElementProps {
	/**
	 * Arc Style Select
	 */
	arcsStyle?: 'Hero - Three Lines' | 'Component - Two Lines';
	/**
	 * Arcs Position in Component
	 */
	arcsPosition?: 'Left' | 'Right';
	/**
	 * Arc One Color - HEX Value
	 */
	arcOneColor?: string;
	/**
	 * Arc One Stroke Width
	 * Default: 3
	 */
	arcOneStrokeWidth?: number;
	/**
	 * Arc Two Color - HEX Value
	 */
	arcTwoColor?: string;
	/**
	 * Arc Two Stroke Width
	 * Default: 3
	 */
	arcTwoStrokeWidth?: number;
	/**
	 * Arc Three Color - HEX Value
	 * Only for Hero - Three Lines
	 */
	arcThreeColor?: string;
	/**
	 * Arc Three Stroke Width
	 * Only for Hero - Three Lines
	 * Default: 3
	 */
	arcThreeStrokeWidth?: number;
	animationDelay?: number;
	animationOffset?: number;
	disableAnimation?: boolean;
}

const AnimatedArcs: React.FC<IAnimatedArcsProps> = ({
	id,
	className,
	classNames = [],
	arcsStyle,
	arcsPosition,
	arcOneColor,
	arcOneStrokeWidth,
	arcTwoColor,
	arcTwoStrokeWidth,
	arcThreeColor,
	arcThreeStrokeWidth,
	animationDelay,
	animationOffset,
	disableAnimation = false,
}) => {
	const [isDomLoaded, setIsDomLoaded] = useState(false);

	useEffect(() => {
		setIsDomLoaded(true);
	}, []);

	let arcContent = null;

	switch (arcsStyle) {
		case 'Hero - Three Lines':
			arcContent = (
				<>
					<AnimationOnScroll
						animateIn={
							disableAnimation
								? 'hero-three-lines__static'
								: 'hero-three-lines__animation'
						}
						animateOnce={true}
						delay={disableAnimation ? 0 : animationDelay}
						offset={animationOffset}
						initiallyVisible={false}
					>
						<HeroArcs
							strokeOneColor={arcOneColor}
							strokeOneWidth={arcOneStrokeWidth}
							strokeTwoColor={arcTwoColor}
							strokeTwoWidth={arcTwoStrokeWidth}
							strokeThreeColor={arcThreeColor}
							strokeThreeWidth={arcThreeStrokeWidth}
						/>
					</AnimationOnScroll>
				</>
			);
			break;
		case 'Component - Two Lines':
			arcContent = (
				<>
					<AnimationOnScroll
						animateIn={
							disableAnimation
								? 'component-two-lines__static'
								: 'component-two-lines__animation'
						}
						animateOnce={true}
						delay={disableAnimation ? 0 : animationDelay}
						offset={animationOffset}
						initiallyVisible={false}
					>
						<Arc
							className="arc-two"
							strokeColor={arcTwoColor}
							strokeWidth={arcTwoStrokeWidth}
						/>
						<Arc
							className="arc-one"
							strokeColor={arcOneColor}
							strokeWidth={arcOneStrokeWidth}
						/>
					</AnimationOnScroll>
				</>
			);
			break;
	}

	if (!isDomLoaded) {
		return null;
	} else {
		return (
			<div
				id={id}
				className={
					className ||
					cn(
						`calian-animated-arcs animation-position-${kebabCase(
							arcsPosition,
						)}`,
						...classNames,
					)
				}
			>
				{arcContent}
			</div>
		);
	}
};

export default AnimatedArcs;
